import { useState, useEffect } from 'react';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import { useParams, useHistory } from 'react-router';
import StreamingPopup from 'app/admin/device/component/StreamingPopup';
import MeasurementEditService from '../service/MeasurementEditService';
import DeviceEditService from '../../device/service/DeviceEditService';

function MeasurementEditForm(props) {
	const resolveMeasurementId = (result) => result?.id ?? result?.measurementId ?? result?.measurement_id ?? result?.properties?.id ?? null;

	const resolveDeviceName = (deviceId, formData) => {
		const list = formData?.entityMap?.device ?? [];
		const found = list.find(
			(d) => d?.id === deviceId || d?.externalId === deviceId || d?.value === deviceId
		);
		return found?.name || found?.text || '';
	};

	const config = data => {
		return {
			key: 'measurementEditForm',
			text: 'Measurement',
			textKey: 'measurement',
			service: MeasurementEditService,
			// hideSaveButton: true,
			// noNavigationAfterSave: true,
			// noNavigationAfterSaveNewLink: result => `/measurement/${props.type}/${result.id}`,
			defaultValue: () =>
				new Promise((resolve, reject) =>
					resolve({
						id: null,
						device: null,
						project: null,
						location: null,
						// recordingType: props.type === 'stream' ? 'STREAM' : 'NORMAL',
						// recordTimeInSec: null
					})
				),
			otherSaveButtonList: [
				{
					key: 'startMeasureInBG',
					icon: 'play_arrow',
					place: 'before',
					text: 'Start Recording in the Background',
					afterSave: async (result) => {
						const measurementId = resolveMeasurementId(result);
						if (!measurementId) throw new Error('Missing measurement id.');
						await MeasurementEditService.startRecording(measurementId);
						return { navigate: true };
					},
				},
				{
					key: 'startMeasure',
					icon: 'play_arrow',
					place: 'before',
					text: 'Start Recording',
					skipSave: true,
					afterSave: async (formValues) => {
						const rawDevice = formValues?.dto?.device ?? formValues?.device;
						const deviceId = typeof rawDevice === 'object' ? (rawDevice?.id ?? rawDevice?.value) : rawDevice;
						const measurementName = (formValues?.dto?.name ?? formValues?.name ?? '').trim();
						if (!deviceId) throw new Error('Missing device id.');
						if (!measurementName) throw new Error('Missing measurement name.');

						await DeviceEditService.startStreamingRecording(deviceId, measurementName);

						const deviceName = resolveDeviceName(deviceId, formData);
						setStreamingItem({ id: deviceId, name: deviceName });

						return { navigate: false };
					}
				}
			],
			fields: [
				{
					key: 'name',
					text: 'Name',
					textKey: 'name',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'project',
					text: 'Project',
					textKey: 'project',
					component: EditFormSelectField,
					items: data.formData.entityMap.project,
					required: true
				},
				{
					key: 'location',
					text: 'Location',
					textKey: 'location',
					component: EditFormTextField,
					readOnly: true,
					required: true
				},
				{
					key: 'device',
					text: 'Device',
					textKey: 'device',
					component: EditFormSelectField,
					items: data.formData.entityMap.device,
					readOnly: true,
					required: true
				},
				// {
				// 	key: 'recordTimeInSec',
				// 	text: 'Record Time in Sec',
				// 	textKey: 'recordTimeInSec',
				// 	component: EditFormTextField,
				// 	type: 'number',
				// 	required: props.type === 'stream',
				// 	helperText: props.type === 'record' ? 'Ha nem tölti ki, gombnyomásra lehet leállítani a rögzítést a következő ablakban.' : null
				// }
			]
		};
	};
	const { id } = useParams();
	const [formData, setFormData] = useState(null);
	const [formDataError, setFormDataError] = useState(null);
	const [streamingItem, setStreamingItem] = useState(null);
	const [data, setData] = useState(null);
	const history = useHistory();

	const [streaming, setStreaming] = useState({ open: false, deviceId: null, deviceName: '', measurementId: null, payload: null, });

	useEffect(() => {
		let mounted = true;
		setFormDataError(null);
		MeasurementEditService.getFormData()
			.then((result) => mounted && setFormData(result))
			.catch((err) => mounted && setFormDataError(err));
		return () => { mounted = false; };
	}, []);

	if (formData == null) {
		MeasurementEditService.getFormData().then(result => setFormData(result));
		return <></>;
	}
	const myConfig = config({ formData });
	return (
		<div>
			<EditFormPage config={myConfig} onDataChanged={d => setData(d)} />
			{streamingItem && (
				<StreamingPopup
					item={streamingItem}
					onClose={() => {
						setStreamingItem(null)
						history.goBack();
					}}
				/>
			)}
		</div>
	);
}

export default MeasurementEditForm;
